import { PropsWithChildren } from 'react';
import { Box, BoxProps, Flex } from 'reflexbox';
import styled from 'styled-components';

const ToolbarContainer = styled(Flex)<{ compact?: boolean }>`
	gap: ${(props) => (props.compact ? '4px 8px' : '10px 20px')};
	> * {
		flex-grow: 0;
		flex-shrink: 0;
	}
`;

export function Toolbar(props: PropsWithChildren<BoxProps & { compact?: boolean }>) {
	return <ToolbarContainer {...props} />;
}

Toolbar.Spacing = styled(Box)`
	flex-grow: 1 !important;
	flex-shrink: 1 !important;
`;
